import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Objects, Parts, Types} from "components";
import API from "@beardeddevops/react.api";
import APPCONFIG from "constants/Config";
import moment from "moment-timezone";
import ReactToPrint from "react-to-print";
import {confirmAlert} from "react-confirm-alert";
import {Alert, Button, Card, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import UserRoles from "../../constants/UserRoles";
import {CardContent, Tooltip} from "@material-ui/core";
import CardActions from "@material-ui/core/CardActions";
import ScannableCard, {scannableCardPrintStyle} from "components/Elements/ScannableCard";

const getCustomerBarcodeLabelName = (rootState = {}) => {
	const location = rootState.location || {};
	return location.store_name || location.storeName || location.name || location.Name || rootState.store_name || 'Store Barcode';
};

/**
 *  @property {Customers_Object} state
 *  @property {object} model
 *  @property {Customers_Properties} model.properties
 *  @property {Customers_Is} model.is
 *  @property {Customers_Has} model.has
 */
class Customer extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Customers._name);
		this.redirect = this.props.baseUrl;
		this.state.customer_barcodes = [];
		this.state.customer_barcode = "";
		this.state.customerBarcodeLoading = false;
		this.state.customerBarcodeCapture = false;
		this.state.customerBarcodeTableMissing = false;
		this.customerBarcodeCaptureHandler = null;
	}

	/**
	 * @param prevProps
	 * @param {Customers_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if (typeof this.props.updateName === 'function') {
			this.props.updateName(this.state.name);
		}
		if (!this.props.disableFields && this.state.pkey && this.state.pkey !== prevState.pkey) {
			void this.loadCustomerBarcodes(this.state.pkey);
		}
	}

	componentWillUnmount() {
		this.clearCustomerBarcodeCapture(false);
		if (super.componentWillUnmount) {
			super.componentWillUnmount();
		}
	}


	copyToFflBoss = async () => {
		let cModel = new API.BuildClass(Types.Customers._name, 'POST_FFL_CUSTOMER_COPY');
		let result = await cModel.submit(this, 'POST_FFL_CUSTOMER_COPY');
	}

	loadCustomerBarcodes = async (customerPkey = this.state.pkey) => {
		if (!customerPkey) {
			return;
		}

		try {
			const data = await $.ajax({
				type: "GET",
				url: `${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}/customers/${customerPkey}/barcodes`,
			});
			const response = data && typeof data.response !== 'undefined' ? data.response : data;
			this.setState({
				customer_barcodes: Array.isArray(response?.barcodes) ? response.barcodes : [],
				customerBarcodeTableMissing: !!response?.table_missing,
			});
		} catch (error) {
			this.setState({
				customer_barcodes: [],
			});
		}
	}

	handleCustomerBarcodeInput = (event) => {
		this.setState({customer_barcode: event.target.value});
	}

	saveCustomerBarcode = async (barcode = this.state.customer_barcode, source = 'external') => {
		const customerPkey = this.state.pkey;
		const normalizedBarcode = String(barcode || '').trim();
		if (!customerPkey || !normalizedBarcode) {
			API.Toast.error('Enter or scan a barcode before saving.', {
				position: API.Toast.POSITION.TOP_CENTER
			});
			return;
		}

		this.setState({customerBarcodeLoading: true});
		try {
			const data = await $.ajax({
				type: "POST",
				url: `${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}/customers/${customerPkey}/barcodes`,
				data: {
					object: JSON.stringify({
						barcode: normalizedBarcode,
						source,
					}),
				},
			});
			const response = data && typeof data.response !== 'undefined' ? data.response : data;
			this.setState({
				customer_barcodes: Array.isArray(response?.barcodes) ? response.barcodes : [],
				customer_barcode: "",
				customerBarcodeTableMissing: false,
			});
			API.Toast.success('Customer barcode saved.', {
				position: API.Toast.POSITION.TOP_RIGHT
			});
		} catch (error) {
			API.Toast.error(error?.responseJSON?.response || 'Unable to save that customer barcode.', {
				position: API.Toast.POSITION.TOP_CENTER
			});
		} finally {
			this.setState({customerBarcodeLoading: false});
		}
	}

	generateCustomerBarcode = async () => {
		const customerPkey = this.state.pkey;
		if (!customerPkey) {
			return;
		}

		this.setState({customerBarcodeLoading: true});
		try {
			const data = await $.ajax({
				type: "POST",
				url: `${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}/customers/${customerPkey}/generate_barcode`,
				data: {
					object: JSON.stringify({}),
				},
			});
			const response = data && typeof data.response !== 'undefined' ? data.response : data;
			this.setState({
				customer_barcodes: Array.isArray(response?.barcodes) ? response.barcodes : [],
				customerBarcodeTableMissing: false,
			});
			API.Toast.success('Customer barcode generated.', {
				position: API.Toast.POSITION.TOP_RIGHT
			});
		} catch (error) {
			API.Toast.error(error?.responseJSON?.response || 'Unable to generate a customer barcode.', {
				position: API.Toast.POSITION.TOP_CENTER
			});
		} finally {
			this.setState({customerBarcodeLoading: false});
		}
	}

	deleteCustomerBarcode = (barcodePkey) => {
		confirmAlert({
			title: 'Delete Customer Barcode',
			message: 'This will remove the selected barcode from this customer. Continue?',
			buttons: [
				{
					label: 'Yes',
					onClick: () => {
						void this.deleteCustomerBarcodeConfirmed(barcodePkey);
					},
				},
				{
					label: 'No',
					onClick: () => {},
				},
			],
		});
	}

	deleteCustomerBarcodeConfirmed = async (barcodePkey) => {
		const customerPkey = this.state.pkey;
		if (!customerPkey || !barcodePkey) {
			return;
		}

		this.setState({customerBarcodeLoading: true});
		try {
			const data = await $.ajax({
				type: "DELETE",
				url: `${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}/customers/${customerPkey}/barcodes`,
				data: {
					object: JSON.stringify({
						barcode_pkey: barcodePkey,
					}),
				},
			});
			const response = data && typeof data.response !== 'undefined' ? data.response : data;
			this.setState({
				customer_barcodes: Array.isArray(response?.barcodes) ? response.barcodes : [],
				customerBarcodeTableMissing: false,
			});
			API.Toast.success('Customer barcode deleted.', {
				position: API.Toast.POSITION.TOP_RIGHT
			});
		} catch (error) {
			API.Toast.error(error?.responseJSON?.response || 'Unable to delete that customer barcode.', {
				position: API.Toast.POSITION.TOP_CENTER
			});
		} finally {
			this.setState({customerBarcodeLoading: false});
		}
	}

	captureCustomerBarcode = () => {
		this.clearCustomerBarcodeCapture();
		this.customerBarcodeCaptureHandler = (barcode) => {
			this.clearCustomerBarcodeCapture();
			this.setState({
				customer_barcode: barcode,
				customerBarcodeCapture: false,
			}, () => {
				void this.saveCustomerBarcode(barcode, 'external');
			});
			return true;
		};
		window.BestPOSCustomerBarcodeCapture = this.customerBarcodeCaptureHandler;
		this.setState({customerBarcodeCapture: true});
	}

	clearCustomerBarcodeCapture = (updateState = true) => {
		if (window.BestPOSCustomerBarcodeCapture === this.customerBarcodeCaptureHandler) {
			delete window.BestPOSCustomerBarcodeCapture;
		}
		this.customerBarcodeCaptureHandler = null;
		if (updateState && this.state?.customerBarcodeCapture) {
			this.setState({customerBarcodeCapture: false});
		}
	}

	renderCustomerBarcodes = () => {
		const barcodes = Array.isArray(this.state.customer_barcodes) ? this.state.customer_barcodes : [];
		const customerName = this.state.name || 'Customer';
		const labelName = getCustomerBarcodeLabelName(this.props.rootState);
		if (!this.state.pkey || this.props.disableFields) {
			return null;
		}

		return (
			<fieldset style={{marginTop: 20}}>
				<div className={"row"}>
					<div className={"col"}>
						<h4 className={'section-title'}>Customer Barcodes</h4>
						{this.state.customerBarcodeTableMissing &&
							<Alert color="warning">
								Customer barcode storage is not installed yet. Run the provided SQL before saving barcodes.
							</Alert>}
						<div className={"row"}>
							<div className={"col-6"}>
								<div className="form-group">
									<span className="input-label">In-House Barcode</span>
									<input
										className="form-control"
										value={this.state.customer_barcode || ""}
										disabled={this.state.customerBarcodeLoading}
										onChange={this.handleCustomerBarcodeInput}
									/>
								</div>
							</div>
							<div className={"col-6"} style={{display: 'flex', alignItems: 'flex-end', gap: 8, paddingBottom: 16}}>
								<Button className="primary-button"
									disabled={this.state.customerBarcodeLoading || !this.state.customer_barcode}
									onClick={() => this.saveCustomerBarcode()}
								>
									Save Barcode
								</Button>
								<Button
									color={this.state.customerBarcodeCapture ? "secondary" : "info"}
									disabled={this.state.customerBarcodeLoading}
									onClick={this.state.customerBarcodeCapture ? this.clearCustomerBarcodeCapture : this.captureCustomerBarcode}
									style={{ borderRadius: '6px' }}
								>
									{this.state.customerBarcodeCapture ? "Cancel Scan" : "Capture Scan"}
								</Button>
								<Button
									className="secondary-button"
									disabled={this.state.customerBarcodeLoading}
									onClick={this.generateCustomerBarcode}
								>
									Generate POS Barcode
								</Button>
							</div>
						</div>
						{this.state.customerBarcodeCapture &&
							<Alert color="info">Scan the customer card now. The scan will be saved to this customer.</Alert>}
						{barcodes.length > 0 ?
							<div className="table-responsive">
								<table className="table table-sm table-striped">
									<thead>
										<tr>
											<th>Preview</th>
											<th>Barcode</th>
											<th>Source</th>
											<th>Created</th>
											<th/>
										</tr>
									</thead>
									<tbody>
										{barcodes.map((barcode) => {
											const printableRef = `customerBarcodePrintable${barcode.pkey}`;
											return (
												<tr key={barcode.pkey}>
													<td>
														<ScannableCard
															barcode={barcode.barcode}
															name={customerName}
															title={labelName}
															compact={true}
														/>
													</td>
													<td><code>{barcode.barcode}</code></td>
													<td>{barcode.source === 'generated' ? 'POS' : 'Third Party'}</td>
													<td>{barcode.created ? moment(barcode.created).local().format("MM/DD/YYYY hh:mm A") : 'N/A'}</td>
													<td>
														<div className="no-screen">
															<ScannableCard
																ref={el => (this[printableRef] = el)}
																barcode={barcode.barcode}
																name={customerName}
																title={labelName}
															/>
														</div>
														<div style={{display: 'flex', gap: 8}}>
															<ReactToPrint
																trigger={() =>
																	<Button className="secondary-button" size="sm">
																		<i className="fa fa-print"/>&nbsp;&nbsp;Print
																	</Button>
																}
																content={() => this[printableRef]}
																copyStyles={false}
																pageStyle={scannableCardPrintStyle}
																bodyClass={""}
															/>
															<Button
																color="danger"
																size="sm"
																disabled={this.state.customerBarcodeLoading}
																onClick={() => this.deleteCustomerBarcode(barcode.pkey)}
															>
																<i className="fa fa-trash"/>&nbsp;&nbsp;Delete
															</Button>
														</div>
													</td>
												</tr>
											);
										})}
									</tbody>
								</table>
							</div>
							: <p>No customer barcodes saved.</p>}
					</div>
				</div>
			</fieldset>
		);
	}

	//Note: Doesn't need a form() function. Only ever used in a modal
	render() {
		/**
		 * @param {Customers_Properties} data
		 */
		let {properties} = this.model
		/**
		 * @type {Customers_Object} object
		 */
		let object = this.state
		let {loading} = this.state
		let {disableFields} = this.props
		//currently this is only passed via CheckoutCustomer

		return (
			<Card style={{overflow: 'visible', border: "none", boxShadow: "none"}}>
				<CardContent style={{padding: 0}}>
					<fieldset>
						<div className={"row"}>
							<div className={"col"}>

								<h4 className={'section-title'}>Contact Information</h4>

								<div className={'row'}>
									<div className={disableFields ? 'col-7' : 'col-9'}>
										<div className="form-group">
											<Framework.Elements.TextField
												disabled={disableFields}
												property={properties.name}
												value={object.name}
												error={object.name_error}
												update={this.handleTextFieldPropertyUpdate}
												label={'Name'}
											/>
										</div>
									</div>
									<div className={disableFields ? 'col-5' : 'col-3'}>
										<div className="form-group">
											<Framework.Elements.PhoneNumber
												disabled={disableFields}
												property={properties.phone}
												value={object.phone}
												error={object.phone_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
								</div>

								<div className={'row'}>
									<div className={disableFields ? 'col-7' : 'col-9'}>
										<div className="form-group">
											<Framework.Elements.EmailAddress
												disabled={disableFields}
												property={properties.email}
												value={object.email}
												error={object.email_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
									<div className={disableFields ? 'col-5' : 'col-3'}>
										<div className={"form-group"}>
											<Framework.Elements.Date
												disabled={disableFields}
												label={"Birth Date"}
												value={object.birth_date}
												error={object.birth_date_error}
												property={properties.birth_date}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
								</div>

							</div>
						</div>
					</fieldset>
					{this.renderCustomerBarcodes()}
				</CardContent>
				<CardActions style={{justifyContent: 'flex-end', padding: '14px'}}>
					{/* New button that will go to the far left */}
					{this.props.rootState.ffl_boss_linked && this.state.pkey && <Button
						color="info"
						style={{marginRight: 'auto'}}
						onClick={this.copyToFflBoss}
					>
						Copy Customer to FFL Boss
					</Button>}

					{this.props.goBack &&
						<Button className="secondary-button" onClick={() => (this.props.history.goBack())}>Back</Button>
					}
					{this.props.noDelete &&
						<Button color="danger" className='danger-button' data-id={this.props.dataIdDelete} onClick={this.handleDelete}>{this.props.deleteText ? this.props.deleteText : "Delete"}</Button>
					}
					{this.props.hideSave ? null : this.props.dataIdSave ?
						<Button className="primary-button" data-id={this.props.dataIdSave} onClick={this.handleSubmit}>Save</Button>
						:
						<Button className="primary-button" onClick={this.handleSubmit}>Save</Button>
					}
				</CardActions>
				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</Card>
		)
	}

}

export default Framework.Components.withRootState(Customer);
